import React from 'react';
import { ArrowRight } from 'lucide-react';
export function NextStep() {
  return <section className="relative py-24 px-6 md:px-12 bg-dark text-white" data-id="element-126">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 bg-cover bg-center opacity-40" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1522204523234-8729aa6e3d5f?q=80&w=2000&auto=format&fit=crop)'
    }} data-id="element-127">
        <div className="absolute inset-0 bg-dark/90" data-id="element-128"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-129">
        <div className="text-center mb-16" data-id="element-130">
          <div className="section-badge text-white justify-center" data-id="element-131">
            YOUR FUTURE STARTS HERE
          </div>
          <h2 className="text-4xl md:text-5xl font-bold leading-tight" data-id="element-132">
            TAKE THE NEXT STEP{' '}
            <span className="text-primary" data-id="element-133">TOWARD YOUR FUTURE</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24" data-id="element-134">
          {/* Left Column */}
          <div className="bg-dark-lighter/80 p-8 md:p-12 border border-gray-800 backdrop-blur-sm relative" data-id="element-135">
            {/* Accent line */}
            <div className="absolute left-0 top-12 bottom-12 w-1 bg-primary" data-id="element-136"></div>

            <h3 className="text-3xl font-bold mb-4" data-id="element-137">
              LOOKING FOR A NEW OPPORTUNITY?
            </h3>
            <p className="text-gray-400 text-lg mb-8" data-id="element-138">
              Join a team that values your skills and dedication. We're always
              looking for experienced craftsmen to fill roles in marine,
              industrial, and construction sectors. Apply today to start your
              journey with BND.
            </p>
            <button className="btn-white text-dark w-fit group" data-id="element-139">
              FIND YOUR NEXT JOB
              <div className="bg-primary text-white rounded-full p-1 group-hover:bg-primary-hover transition-colors" data-id="element-140">
                <ArrowRight size={16} data-id="element-141" />
              </div>
            </button>
          </div>

          {/* Right Column */}
          <div className="bg-dark-lighter/80 p-8 md:p-12 border border-gray-800 backdrop-blur-sm relative" data-id="element-142">
            {/* Accent line */}
            <div className="absolute left-0 top-12 bottom-12 w-1 bg-primary" data-id="element-143"></div>

            <h3 className="text-3xl font-bold mb-4" data-id="element-144">LOOKING FOR CRAFTSMEN?</h3>
            <p className="text-gray-400 text-lg mb-8" data-id="element-145">
              Partner with BND Contracting to secure the skilled labor you need
              for your next project. We thoroughly vet our craftsmen to ensure
              they meet your standards for safety, quality, and reliability.
            </p>
            <button className="btn-white text-dark w-fit group" data-id="element-146">
              EXPLORE SOLUTIONS
              <div className="bg-primary text-white rounded-full p-1 group-hover:bg-primary-hover transition-colors" data-id="element-147">
                <ArrowRight size={16} data-id="element-148" />
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>;
}